import { StreamChat } from 'stream-chat';

export type StateType = {
  chatClient: StreamChat | undefined;
  unreadCount: number;
  isInitializingChat: boolean;
};

export type ActionType =
  | { type: 'updateUnreadCount'; payload: { unreadCount: number } }
  | {
      type: 'beginChatClientInitialization';
    }
  | { type: 'completeChatClientInitialization'; payload: { chatClient: StreamChat; unreadCount: number } };

export const chatReducer = (state: StateType, action: ActionType) => {
  switch (action.type) {
    case 'beginChatClientInitialization': {
      return { ...state, isInitializingChat: true };
    }
    case 'completeChatClientInitialization': {
      const { chatClient, unreadCount } = action.payload;
      return { ...state, isInitializingChat: false, chatClient, unreadCount };
    }

    case 'updateUnreadCount': {
      const { unreadCount } = action.payload;
      return { ...state, unreadCount };
    }

    default:
      return state;
  }
};
